<template>
  <b-card class="h-100">
    <b-card-title class="mb-4"> Météo</b-card-title>
    <b-row class="align-items-center overflow-auto" v-if="currentLocationAccess && loaded">
      <b-col cols="3">
        <div class="square bg-light p-2 d-flex flex-column align-items-center rounded-lg mb-2">
          <div class="text-center font-size-22">{{ date.getDate() }}</div>
          <div class="text-center font-size-20">
            {{ new Intl.DateTimeFormat('fr-FR', { month: 'short' }).format(date).toUpperCase() }}
          </div>
        </div>
        <div class="square bg-light p-2 d-flex flex-column align-items-center rounded-lg mb-2">
          <div class="text-center font-size-22">{{ weather.temp }} °C</div>
        </div>
        <div class="square bg-light p-2 d-flex flex-column align-items-center rounded-lg">
          <div class="text-center font-size-22">{{ date | formatHour }}</div>
        </div>
      </b-col>
      <b-col class="d-flex flex-column align-items-center" cols="9" v-if="loaded">
        <h5>
          {{ weather.city }}
        </h5>
        <img style="width: 100px" :src="require(`../../../assets/icons/${weather.icon}.svg`)" alt="weather" />
        <div class="d-flex justify-content-around w-100">
          <h6>Min : {{ weather.minTemp }}°C</h6>
          <h6>Max : {{ weather.maxTemp }}°C</h6>
        </div>
      </b-col>
    </b-row>
    <h-e-spinner v-if="!loaded && currentLocationAccess"></h-e-spinner>
    <h4 v-if="!currentLocationAccess" class="text-primary text-center">Nous n'avons pas accès à votre localisation</h4>
  </b-card>
</template>

<script>
import moment from 'moment'
import { APIRequest } from '@/node-sdk'

export default {
  name: 'weather',

  data() {
    return {
      weather: {
        minTemp: 0,
        maxTemp: 0,
        temp: 0,
        description: null,
        icon: null,
        city: null,
      },
      date: new Date(),
      currentLocationAccess: true,
      loaded: false,
      icons: {
        '01d': 'day',
        '01n': 'night',
        '02d': 'cloudy-day-3',
        '02n': 'cloudy-night-3',
        '03d': 'cloudy',
        '03n': 'cloudy',
        '04d': 'cloudy',
        '04n': 'cloudy',
        '09d': 'rainy-5',
        '09n': 'rainy-5',
        '10d': 'rainy-2',
        '10n': 'rainy-2',
        '11d': 'thunder',
        '11n': 'thunder',
        '13d': 'snowy-5',
        '13n': 'snowy-5',
        '50d': 'cloudy',
        '50n': 'cloudy',
      },
    }
  },

  filters: {
    formatHour: function (date) {
      return moment(date).format('HH:mm')
    },
  },

  mounted() {
    this.getUserPosition()
    this.$forceUpdate()
  },

  methods: {
    getUserPosition() {
      navigator.geolocation.getCurrentPosition(this.successFunction, this.errorFunction)
    },

    successFunction(position) {
      console.log(position)
      let self = this
      APIRequest.get_object_with_request(
        process.env.VUE_APP_DASHBOARD_API,
        'weather-infos',
        `?lat=${position.coords.latitude}&lon=${position.coords.longitude}`,
      ).then(function (result) {
        self.weather.city = result.name
        self.weather.minTemp = Number(result.main.temp_min) - 273
        self.weather.maxTemp = Number(result.main.temp_max) - 273
        self.weather.temp = Number(result.main.temp) - 273
        self.weather.description = result.weather[0].description
        self.weather.icon = self.icons[result.weather[0].icon]

        self.weather.minTemp = Number(self.weather.minTemp).toFixed(0)
        self.weather.maxTemp = Number(self.weather.maxTemp).toFixed(0)
        self.weather.temp = Number(self.weather.temp).toFixed(0)

        self.loaded = true
      })
    },

    errorFunction() {
      this.currentLocationAccess = false
    },
  },

  computed: {},
}
</script>

<style scoped lang="scss"></style>
